<script>
import Divider from "@/components/atoms/divider";
import Titre from "@/components/atoms/titre";

import ButtonIcon from "@/components/molecules/button-icon";
import FormInput from "@/components/molecules/form-input";
import PopinAnchor from "@/components/molecules/popin-anchor";
import Form from "@/components/molecules/form";
import FormGroup from "@/components/molecules/form-group";
import {
  formValidationProps,
  useFormValidation
} from "@/components/organisms/mixins/form-validation.mixin";
import {
  shippingMethodPhoneEmits,
  shippingMethodPhoneProps,
  useShippingMethodPhone
} from "./mixin";

export default {
  name: "ShippingMethodPhone",
  components: {
    Form,
    FormGroup,
    Divider,
    ButtonIcon,
    FormInput,
    PopinAnchor,
    Titre
  },
  props: { ...formValidationProps(), ...shippingMethodPhoneProps() },
  emits: ["setAlertSmsPhone", ...shippingMethodPhoneEmits()],
  setup(props, context) {
    const { v$, getState, getErrorMessage } = useFormValidation(props);
    const { tel_alerte_sms, mounted } = useShippingMethodPhone(props, context);

    onMounted(mounted);
    return {
      v$,
      getState,
      getErrorMessage,
      tel_alerte_sms
    };
  },
  validations() {
    return {
      tel_alerte_sms: {
        telMobile
      }
    };
  }
};
</script>

<template>
  <Form>
    <div class="u-flex u-flex-align-center u-my-md">
      <Titre
        tag="h2"
        size="xs"
      >
        Suivi de commande par SMS
      </Titre>
      <Divider
        class="u-flex-item-fluid u-ml-xs"
        dotted
      />
    </div>
    <div class="c-shipping-phone">
      <p class="u-font-15">
        <template v-if="isEnabled">
          Vous serez notifié(e) de l’évolution de votre commande au numéro suivant :
        </template>
        <template v-else>
          Astuce : Vous pouvez être notifié(e) de l'évolution de votre commande par SMS.<br>
          Rendez-vous dans votre compte client pour activer cette option.
        </template>
      </p>
      <FormGroup
        v-if="isEnabled"
        :state="getState(v$,'tel_alerte_sms')"
        class="u-mt-sm"
      >
        <div class="u-flex u-flex-align-center">
          <div class="u-flex-item-fluid">
            <FormInput
              v-model="tel_alerte_sms"
              :state="getState(v$,'tel_alerte_sms')"
              type="tel"
              size="lg"
              class="c-shipping-phone__input"
              @blur="v$.tel_alerte_sms.$touch(); $emit('setAlertSmsPhone', tel_alerte_sms)"
            >
              Votre N° de portable (06 ou 07)
            </FormInput>
          </div>
          <PopinAnchor
            link
            open-on-hover
            icon-position="left"
            infobulle
            popin-size="sm"
            class="u-ml-sm"
          >
            <template #button-content>
              <ButtonIcon
                icon-name="info"
                size="xs"
                radius="full"
                variant="grey-2"
                icon-color="grey-2"
                icon-color-hover="white"
                outline
              />
            </template>
            <p class="u-font-14 u-color-text">
              <template v-if="isLad">
                A noter : Si vous modifiez ce numéro de portable, cela modifiera celui utilisé par défaut dans votre adresse de livraison.
              </template>
              <template v-else>
                Pour modifier le numéro de portable utilisé par défaut rendez-vous dans votre compte client
              </template>
            </p>
          </PopinAnchor>
        </div>
        <template #message>
          <p>
            {{ getErrorMessage("tel_alerte_sms", "Veuillez entrer un numéro de téléphone mobile valide qui contient entre 6 et 20 caractères et commençant par 06 ou 07") }}
          </p>
        </template>
      </FormGroup>
    </div>
  </Form>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/shipping-phone.scss";
</style>
